// extracted by mini-css-extract-plugin
export default {"currencyIcon":"xFYxR8wJnmEvRwd78BaA"};